import { Injectable } from '@angular/core';
import { defaultDwopenEndpoint, environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class InstanceService {

    get prefixKey() : string { return this.cookieService.check("app-center-instance") ? this.cookieService.get("app-center-instance") : this.environment.defaultSourcePrefix }

    // using a property allow us to mock the environment object in tests
    get environment() { return environment; }
    get defaultDwopenEndpoint() { return defaultDwopenEndpoint; }

    get instance() { return this.prefixKey ? this.environment.instances[this.prefixKey] : null };
    get appCenterUrl() : string {return this.instance?.appCenter ?? null }
    get appCenterCurrentInstance() { return this.instance?.name ?? null }
    get appCenterInstanceUrl() { return this.instance?.instancesUrl ?? null }
    get appCenterLnfUrl() { return this.instance?.lnfUrl ?? null }
    get appCenterEndpoint() { return this.instance?.endpoint  ?? this.defaultDwopenEndpoint; }

    //onboarding env
    get toesApi(): string {
       return this.instance?.toesApi ?? null;
    }

    get telitIccidPrefix(): string {
        return this.instance?.telitIccidPrefix ?? '';
    }

    get defaultDeviceTypes(): any {
        return this.instance?.defaultDeviceTypes ?? {};
    }

    constructor(private cookieService: CookieService) { }
}
